<template>
 <div class="table ReplenishmentDropdownTable">
  <table>
    <thead>
      <tr>
        <th>
          ID
        </th>
        <th>
          Datum
        </th>
        <th>
          Actie
        </th>
      </tr>
    </thead>

    <tbody v-if="exportItems.length">
       <template v-for="(item, index) in exportItems">
         <tr :key="index">
            <td>{{ item.id }}</td>
            <td>{{ moment(item.exportDate).format('YYYY-MM-DD')  }}</td>
            <td> <FormButtonCheckbox class="justify-content-center" :value="true" :active="true" :removeCheckbox="true" @click.native.stop.prevent="exportCsv(item)">
            Download
        </FormButtonCheckbox></td>
         </tr>
       </template>
    </tbody>
    <tbody v-else class="placeholder d-flex justify-content-center align-items-center">
      <span class="spinner-wrapper">
        <div class="spinner-border text-primary m-auto" role="status" key="loading">
          <span class="sr-only">Bezig met laden...</span>
        </div>
      </span>
    </tbody>
  </table>
</div>
</template>

<script>

import FormButtonCheckbox from "src/components/Inputs/FormButtonCheckbox.vue"
import mom from 'moment'
function downloadCSV(csv, filename) {
  let csvFile;
  let downloadLink;

  csvFile = new Blob([csv], {type:"text/csv"});
  downloadLink = document.createElement("a");
  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
}
export default {
  data() {
    return {
      exportItems:[],
    }
  },
  components:{
      FormButtonCheckbox
  },
  mounted:function(){
      this.get_export_data()
  },
  methods:{
    async get_export_data(){
      await this.$handlePromise(
          this.axios.get(`/api/delivery-exports`)
          .then(res => this.exportItems = res.data.results)
          .catch(function (error) {
            console.log(error);
          })
        )
    },
    async exportCsv(item){
        this.$handlePromise(async () => {
          const {data} = await this.axios.get(`/api/delivery-exports/${item.id}`)
          downloadCSV(data, 'delivery_stock'+mom().format('YYYY-MM-DD') + ".csv")
        })
    }
  }
}

</script>

<style>

.ReplenishmentDropdownTable .btn-success {
  padding: 3px 6px !important;
}

</style>

<style scoped lang="scss">

tbody {
  white-space: nowrap;
}

.table {
  margin-bottom: 0;
  table {
    margin: 0px ;
    width: 100%;

    thead {
      tr {
        th {
          border-top: none;
          border-bottom: none;
        }
      }
    }

    tbody {
      td {
        vertical-align: middle;
      }
    }
  }
}

.placeholder {
  height: 100px;
  width: 100%;
  margin-left: 0;

  span {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 50px;
  }
}

td {
  border-top: .5px solid #EFEFF0;
  color: black !important;
  font-size: 13px !important;
}

td + td {
  border-left: .5px solid #EFEFF0;
}

.spinner-border {
  margin: auto;
}

</style>
